import { render, staticRenderFns } from "./OrderDetailPayment.vue?vue&type=template&id=46a9f496&scoped=true&"
import script from "./OrderDetailPayment.vue?vue&type=script&lang=js&"
export * from "./OrderDetailPayment.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailPayment.vue?vue&type=style&index=0&id=46a9f496&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a9f496",
  null
  
)

export default component.exports